export const DEFAULT_MESSAGES = {
	TEMPLATES_DESKTOP: 'Your Selected Ingredients Template:',
	TEMPLATES_MOBILE: 'Your Selected Ingredients Template:'
};
